export const Obrigatorio = () => {
  return (target: any, prop: string) => {
    const NOME_NG_ON_INIT = 'ngOnInit';
    const targetClone: Function = target;
    const ngOnInitClone: Function | null = targetClone[NOME_NG_ON_INIT];
    Object.defineProperty(targetClone, NOME_NG_ON_INIT, {
      value: function () {
        if (!this[prop]) {
          console.error(
            `${targetClone.constructor.name}: ${prop} é obrigatório.`
          );
        }

        if (ngOnInitClone) {
          ngOnInitClone.call(this);
        }
      },
      configurable: true
    });
  };
};
